import { useEffect, useState } from 'react'
import { getVeil, subscribeSecurity } from './security'

/** Reactive privacy-veil flag — re-renders on the 🎭 toggle. */
export function useVeil(): boolean {
  const [veil, setVeil] = useState(getVeil())
  useEffect(() => subscribeSecurity(() => setVeil(getVeil())), [])
  return veil
}
